import Swiper from 'swiper/bundle'
import { lockScroll, unlockScroll } from './scroll_lock'

const SP_MEDIA_QUERY = '(max-width: 988px)'
const MAX_LINE_HEIGHT = 300
const PC_GAP_WIDTH = 6
const MOBILE_GAP_WIDTH = 3

let imageSwiper = null
let modalLayoutFrame = 0

function isMobileViewport() {
  return window.matchMedia(SP_MEDIA_QUERY).matches
}

function isImageModalVisible() {
  const modal = document.getElementById('photo-gallery-image-modal')
  return modal ? modal.classList.contains('visible') : false
}

function scheduleModalLayoutAdjustment() {
  if (!isImageModalVisible()) return
  if (modalLayoutFrame) cancelAnimationFrame(modalLayoutFrame)

  modalLayoutFrame = window.requestAnimationFrame(function () {
    modalLayoutFrame = 0
    if (!isImageModalVisible()) return
    adjustModalLayout()
  })
}

function positionFixedSwiperButtons() {
  const modal = document.getElementById('photo-gallery-image-modal')
  if (!modal) return

  const buttonWrapper = modal.querySelector('.fixed-swiper-button-wrapper')
  const modalContent = modal.querySelector('.modal-content')
  const activeSlide = imageSwiper ? imageSwiper.slides[imageSwiper.activeIndex] : modal.querySelector('.image-slider .swiper-slide')
  const buttonPlaceholder = activeSlide ? activeSlide.querySelector('.swiper-button-placeholder') : null

  if (!buttonWrapper || !modalContent || !buttonPlaceholder || !isMobileViewport()) {
    if (buttonWrapper) {
      buttonWrapper.style.top = ''
      buttonWrapper.style.height = ''
    }
    return
  }

  const contentRect = modalContent.getBoundingClientRect()
  const placeholderRect = buttonPlaceholder.getBoundingClientRect()
  buttonWrapper.style.top = `${Math.round(placeholderRect.top - contentRect.top)}px`
  buttonWrapper.style.height = `${Math.round(placeholderRect.height)}px`
}

function initSwipers() {
  const imageSliderElement = document.querySelector('.image-slider')

  if (!imageSliderElement) return

  const nextEls = Array.from(document.querySelectorAll('.swiper-button-next'))
  const prevEls = Array.from(document.querySelectorAll('.swiper-button-prev'))

  const imageSwiperConfig = {
    zoom: true,
    navigation: {
      nextEl: nextEls,
      prevEl: prevEls,
      addIcons: false,
    },
    on: {
      zoomChange: function (_, scale) {
        this.allowTouchMove = scale <= 1
      },
      slideChange: function () {
        scheduleModalLayoutAdjustment()
      },
    },
  }

  imageSwiper = new Swiper(imageSliderElement, imageSwiperConfig)
  positionFixedSwiperButtons()
}

// --- Justified Layout ---

function rowAssignment() {
  const wrapper = document.getElementById('photo-gallery-container')
  if (!wrapper) return

  const allContainers = Array.from(wrapper.querySelectorAll('.image-container'))
  const pairs = allContainers
    .map(c => ({ container: c, img: c.querySelector('img') }))
    .filter(p => p.img && p.img.naturalWidth > 0)
  if (pairs.length === 0) return

  const images = pairs.map(p => p.img)
  const imageContainers = pairs.map(p => p.container)

  const wrapperWidth = wrapper.clientWidth
  let rows = []
  let containerRows = []
  let oddRow = []
  let containerOddRow = []
  let i = 0
  let nRow = 0
  let sumWideReso = 0

  while (i < images.length) {
    sumWideReso += images[i].naturalWidth / images[i].naturalHeight
    const uniteHeight = Math.floor(wrapperWidth / sumWideReso)

    if (rows[nRow] === undefined) {
      rows[nRow] = []
      containerRows[nRow] = []
    }
    rows[nRow].push(images[i])
    containerRows[nRow].push(imageContainers[i])

    if ((uniteHeight > MAX_LINE_HEIGHT && i !== images.length - 1) || rows[nRow].length === 1) {
      i++
      continue
    } else if (uniteHeight > MAX_LINE_HEIGHT && i === images.length - 1) {
      oddRow = rows[nRow]
      containerOddRow = containerRows[nRow]
      rows.pop()
      containerRows.pop()
      setOddRowHeight(oddRow, containerOddRow)
    }

    sumWideReso = 0
    if (rows[nRow]) {
      setRowHeight(rows[nRow], containerRows[nRow], wrapperWidth)
    }
    nRow++
    i++
  }

  wrapper.style.opacity = '1'
}

function setRowHeight(row, containerRows, wrapperWidth) {
  let rawReso = 0
  const gapWidth = isMobileViewport() ? MOBILE_GAP_WIDTH : PC_GAP_WIDTH

  for (let n = 0; n < row.length; n++) {
    rawReso += row[n].naturalWidth / row[n].naturalHeight
  }

  for (let n = 0; n < row.length; n++) {
    row[n].style.width = ''
    containerRows[n].style.marginRight = 'auto'
    containerRows[n].style.marginLeft = '0px'

    if (row.length === 1) {
      row[n].style.width = '100%'
    } else if (n === row.length - 1) {
      containerRows[n].style.marginRight = '0px'
    } else if (n === 0) {
      rawReso += gapWidth / (wrapperWidth / rawReso)
      containerRows[n].style.marginLeft = '0px'
    } else {
      rawReso += gapWidth / (wrapperWidth / rawReso)
    }
  }

  for (let n = 0; n < row.length; n++) {
    row[n].height = wrapperWidth / rawReso
  }
}

function setOddRowHeight(oddRow, containerOddRow) {
  const gapWidth = isMobileViewport() ? MOBILE_GAP_WIDTH + 'px' : PC_GAP_WIDTH + 'px'

  for (let n = 0; n < oddRow.length; n++) {
    containerOddRow[n].style.width = ''
    containerOddRow[n].style.marginLeft = '0px'
    if (n !== 0) {
      containerOddRow[n].style.marginLeft = gapWidth
    }
    containerOddRow[n].style.marginRight = '0px'
    oddRow[n].height = MAX_LINE_HEIGHT * 0.9
  }
}

// --- Image Modal ---

function visibleImageModal() {
  const imageModalArea = document.getElementById('photo-gallery-image-modal')
  if (!imageModalArea) return
  imageModalArea.classList.add('visible')
  imageModalArea.setAttribute('aria-hidden', 'false')
  lockScroll()
  scheduleModalLayoutAdjustment()
}

function closeImageModal() {
  const imageModalArea = document.getElementById('photo-gallery-image-modal')
  if (!imageModalArea) return
  if (modalLayoutFrame) {
    cancelAnimationFrame(modalLayoutFrame)
    modalLayoutFrame = 0
  }
  imageModalArea.classList.remove('visible')
  imageModalArea.setAttribute('aria-hidden', 'true')
}

function toggleScrollableContent() {
  const modal = document.getElementById('photo-gallery-image-modal')
  if (!modal) return

  modal.querySelectorAll('.gallery-info-content').forEach(function (content) {
    const isScrollableY = content.scrollHeight > content.clientHeight + 1
    const isScrollableX = content.scrollWidth > content.clientWidth + 1

    content.classList.toggle('is-scrollable-y', isScrollableY)
    content.classList.toggle('is-scrollable-x', isScrollableX)
  })
}

function syncGalleryContentHeight() {
  const modal = document.getElementById('photo-gallery-image-modal')
  if (!modal) return

  const isMobile = isMobileViewport()

  modal.querySelectorAll('.swiper-slide').forEach(function (slide) {
    const galleryContent = slide.querySelector('.gallery-content-container')
    const infoContent = slide.querySelector('.gallery-info-content')
    const buttonContainer = slide.querySelector('.button-centering-container')
    const imageContainer = slide.querySelector('.image-slider-container')

    if (!galleryContent || !infoContent) return

    galleryContent.style.height = ''
    infoContent.style.maxHeight = ''

    if (isMobile || !imageContainer) return

    const targetHeight = Math.floor(imageContainer.getBoundingClientRect().height)
    if (targetHeight <= 0) return

    galleryContent.style.height = `${targetHeight}px`

    if (buttonContainer) {
      const buttonHeight = Math.ceil(buttonContainer.getBoundingClientRect().height)
      const marginTop = parseFloat(window.getComputedStyle(buttonContainer).marginTop) || 0
      const infoMaxHeight = Math.max(targetHeight - buttonHeight - marginTop, 0)
      infoContent.style.maxHeight = `${Math.floor(infoMaxHeight)}px`
    }
  })
}

function adjustSwiperHeight() {
  const modal = document.getElementById('photo-gallery-image-modal')
  if (!modal) return
  const modalContent = modal.querySelector('.modal-content')
  const swiperElement = modal.querySelector('.image-slider')

  if (modalContent && swiperElement) {
    swiperElement.style.height = ''
    const swiperContentHeight = swiperElement.scrollHeight

    if (swiperContentHeight > modalContent.clientHeight) {
      swiperElement.style.height = modalContent.clientHeight + 'px'
    }
  }
}

function adjustModalLayout() {
  adjustSwiperHeight()
  syncGalleryContentHeight()
  positionFixedSwiperButtons()
  toggleScrollableContent()
}

function initImageModal() {
  const imageModal = document.getElementById('photo-gallery-image-modal')
  if (!imageModal) return

  const closeButtons = imageModal.querySelectorAll('.modal-close-button')
  const overlay = imageModal.querySelector('.overlay')
  const images = document.querySelectorAll('.photo-gallery-image')

  imageModal.addEventListener('transitionend', function () {
    if (!imageModal.classList.contains('visible')) {
      unlockScroll()
    }
  })

  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', closeImageModal)
  })

  if (overlay) {
    overlay.addEventListener('click', closeImageModal)
  }

  images.forEach(function (image) {
    image.addEventListener('click', function () {
      var index = parseInt(image.getAttribute('data-slide-index'), 10)
      if (imageSwiper) {
        imageSwiper.slideTo(index, 0, false)
      }
      visibleImageModal()
    })
  })
}

// --- Category Filter Modal ---

function initCategoryModal() {
  const categoryModal = document.getElementById('photo-gallery-category-modal')
  if (!categoryModal) return

  const openBtn = document.getElementById('openCategoryModal')
  const closeBtn = document.getElementById('closeCategoryModal')
  const overlay = categoryModal.querySelector('.photo-gallery-category-modal__overlay')
  const resetBtn = document.getElementById('resetCategories')
  const searchBtn = document.getElementById('searchCategories')

  function openModal() {
    categoryModal.classList.add('visible')
    lockScroll()
  }

  function closeModal() {
    categoryModal.classList.remove('visible')
    unlockScroll()
  }

  if (openBtn) openBtn.addEventListener('click', openModal)
  if (closeBtn) closeBtn.addEventListener('click', closeModal)
  if (overlay) overlay.addEventListener('click', closeModal)

  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      var checkboxes = categoryModal.querySelectorAll('.photo-gallery-category-checkbox')
      checkboxes.forEach(function (cb) {
        cb.checked = false
      })
    })
  }

  if (searchBtn) {
    searchBtn.addEventListener('click', function () {
      var checkboxes = categoryModal.querySelectorAll('.photo-gallery-category-checkbox:checked')
      var tags = Array.from(checkboxes).map(function (cb) {
        return cb.value
      })

      if (tags.length > 0) {
        var searchParams = new URLSearchParams({ tags: tags.join('*') })
        location.href = location.origin + '/photos?' + searchParams.toString()
      } else {
        location.href = location.origin + '/photos'
      }
    })
  }
}

// --- Init ---

let resizeTimer = 0

window.addEventListener('resize', function () {
  if (resizeTimer > 0) clearTimeout(resizeTimer)
  resizeTimer = setTimeout(function () {
    rowAssignment()
    scheduleModalLayoutAdjustment()
  }, 0)
})

window.addEventListener('load', rowAssignment)

window.addEventListener('pageshow', function () {
  scheduleModalLayoutAdjustment()
})

document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.getElementById('photo-gallery-container')
  if (wrapper) {
    const observer = new MutationObserver(function () {
      if (resizeTimer > 0) clearTimeout(resizeTimer)
      resizeTimer = setTimeout(rowAssignment, 200)
    })
    observer.observe(wrapper, { attributes: true, attributeFilter: ['style'] })

    wrapper.querySelectorAll('.photo-gallery-image').forEach(function (img) {
      img.addEventListener('load', function () {
        if (resizeTimer > 0) clearTimeout(resizeTimer)
        resizeTimer = setTimeout(rowAssignment, 0)
      })
    })
  }

  initSwipers()
  initImageModal()
  initCategoryModal()

  var lazyImages = document.querySelectorAll('.image-in-modal')
  lazyImages.forEach(function (lazyImage) {
    lazyImage.addEventListener('load', function () {
      scheduleModalLayoutAdjustment()
    })
  })
})
